import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
export function encodePing(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Ping).u32(packet.clientTime >>> 0);
    return writer;
}
export function encodePong(packet, writer = new BinaryWriter(8)) {
    writer.u8(ServerOp.Pong).u32(packet.clientTime >>> 0);
    return writer;
}
/** Serve para Ping e Pong: o corpo é idêntico, só o opcode difere. */
export function decodePing(reader) {
    return { clientTime: reader.u32() };
}
//# sourceMappingURL=ping.js.map